import { createAction, props } from '@ngrx/store';

export const TENANT_SUCCESS = '[Login Page] Tenant Success';

export const tenantSuccess = createAction(
  TENANT_SUCCESS,
  props<any>()
)